import userConfig from "./localDevConfig";
let env = process.env.NODE_ENV; //环境变量
let isHiHonorDomain = true; //用来区别hihonor.com域名为true和honor.com域名为false
export const $memberMixSwitch = true; // 会员融合开关 true：走新登录逻辑, false：走老登录逻辑
const host = window.location.host;
if (env == "development") {
  env = "dev";
} else {
  if (host.startsWith("hd.hihonor.com") || host.startsWith("hd.honor.com")) {
    env = "pro";
  } else if (
    host.startsWith("hd-uat1.test.hihonor.com") ||
    host.startsWith("hd-uat1.test.honor.com")
  ) {
    env = "uat";
  } else {
    env = "sit";
  }
}
if (host.includes("hihonor.com")) {
  isHiHonorDomain = true;
} else if (host.includes("honor.com")) {
  isHiHonorDomain = false;
} else {
  isHiHonorDomain = true;
}
console.log("environment", host, env, isHiHonorDomain);

const multiEnv = {
  dev: {
    queryOperateSpuByCodes: "item-operateSpu/queryOperateSpuByCodes",
    listSpuBySpuCode: "/spu/listSpuBySpuCode",
    getNearByStore: "/online/store-info/get-nearby-store",
    geographyTree: "/metadata/online/geography/tree",
    hdBaseUrl: "https://hd-sit1.test.hihonor.com",
    hdBaseHonorUrl: "https://hd-sit1.test.honor.com"
  },
  sit: {
    baseUrl: "https://retail-sit.test.hihonor.com",
    baseHonorUrl: "https://retail-sit.test.honor.com",
    queryOperateSpuByCodes: "/isrp/ses/item-operateSpu/queryOperateSpuByCodes",
    listSpuBySpuCode: "/isrp/ses/spu/listSpuBySpuCode",
    getNearByStore: "/isrp/sms/online/store-info/get-nearby-store",
    geographyTree: "/isrp/sms/metadata/online/geography/tree",
    hdBaseUrl: "https://hd-sit1.test.hihonor.com",
    hdBaseHonorUrl: "https://hd-sit1.test.honor.com"
  },
  uat: {
    baseUrl: "https://retail-uat.test.hihonor.com",
    baseHonorUrl: "https://retail-uat.test.honor.com",
    queryOperateSpuByCodes: "/isrp/ses/item-operateSpu/queryOperateSpuByCodes",
    listSpuBySpuCode: "/isrp/ses/spu/listSpuBySpuCode",
    getNearByStore: "/isrp/sms/online/store-info/get-nearby-store",
    geographyTree: "/isrp/sms/metadata/online/geography/tree",
    hdBaseUrl: "https://hd-uat1.test.hihonor.com",
    hdBaseHonorUrl: "https://hd-uat1.test.honor.com"
  },
  pro: {
    baseUrl: "https://retail.hihonor.com",
    baseHonorUrl: "https://retail.honor.com",
    queryOperateSpuByCodes: "/isrp/ses/item-operateSpu/queryOperateSpuByCodes",
    listSpuBySpuCode: "/isrp/ses/spu/listSpuBySpuCode",
    getNearByStore: "/isrp/sms/online/store-info/get-nearby-store",
    geographyTree: "/isrp/sms/metadata/online/geography/tree",
    hdBaseUrl: "https://ihlp.hihonor.com",
    hdBaseHonorUrl: "https://ihlp.honor.com"
  }
};
const otherConfig = {
  tenCentMapKey: "3ESBZ-Q5QWI-PSKGI-5ED3F-VX32T-ZQBVI",
  aMapKey: "cbc11d98b3d999b7159beb1a6020a65f",
  hiHonorWxAppId: "gh_1ca59dd4ec37"
};
export const config = {
  env: env,
  queryOperateSpuByCodes: multiEnv[env].queryOperateSpuByCodes,
  listSpuBySpuCode: multiEnv[env].listSpuBySpuCode,
  getNearByStore: multiEnv[env].getNearByStore,
  geographyTree: multiEnv[env].geographyTree,
  baseUrl: isHiHonorDomain ? multiEnv[env].baseUrl : multiEnv[env].baseHonorUrl,
  userInfo: userConfig,
  hdBaseUrl: isHiHonorDomain
    ? multiEnv[env].hdBaseUrl
    : multiEnv[env].hdBaseHonorUrl,
  $memberMixSwitch: $memberMixSwitch,
  otherConfig: otherConfig
};



// WEBPACK FOOTER //
// ./src/api/config.js